/**
 * R10 Wechsel von Status (steuerfrei / Kleinunternehmer / Regelbesteuerung) und Form (SOLL / IST)
 * zum Jahreswechsel ohne Doppel- oder Nichtbesteuerung.
 *
 * - Leistung im nicht regelbesteuerten Jahr bleibt steuerfrei → KU_ALTUMSATZ (T13).
 * - Leistung im Regel-IST-Jahr, Zufluss im Kleinunternehmer-/steuerfreien Jahr → PROFILE_YEAR_MISMATCH (BLOCKER).
 * - IST→SOLL: Leistungen vor dem Wechsel nur über ihre Zahlungen (VIA_PAYMENTS / IST).
 * - SOLL→IST: Zahlungen soll-versteuerter Leistungen ausgeschlossen (ALREADY_SOLL_TAXED).
 *
 * @author Anthony Nahas
 * @since 11.09.26
 */
import {VatEngineInput} from '../types';

export type SollTreatment = 'SOLL' | 'KU_ALTUMSATZ' | 'VIA_PAYMENTS';

export const classifyBookingForSoll = (profileAt: VatEngineInput['profileAt'], leistungDate: Date): SollTreatment => {
    const atLeistung = profileAt(leistungDate);
    if (atLeistung.status !== 'REGELBESTEUERUNG') {
        return 'KU_ALTUMSATZ';
    }
    return atLeistung.form === 'IST' ? 'VIA_PAYMENTS' : 'SOLL';
};

export type IstTreatment = 'IST' | 'KU_ALTUMSATZ' | 'ALREADY_SOLL_TAXED' | 'PROFILE_YEAR_MISMATCH' | 'SOLL_REGIME';

export const classifyPaymentForIst = (
    profileAt: VatEngineInput['profileAt'],
    leistungDate: Date | null,
    paymentDate: Date
): IstTreatment => {
    const atPayment = profileAt(paymentDate);
    const atLeistung = profileAt(leistungDate ?? paymentDate);

    if (atPayment.status === 'REGELBESTEUERUNG' && atPayment.form === 'IST') {
        if (atLeistung.status !== 'REGELBESTEUERUNG') {
            return 'KU_ALTUMSATZ';
        }
        return atLeistung.form === 'SOLL' ? 'ALREADY_SOLL_TAXED' : 'IST';
    }

    // Zahlungsjahr ist SOLL, Kleinunternehmer oder steuerfrei
    if (atLeistung.status === 'REGELBESTEUERUNG' && atLeistung.form === 'IST') {
        return atPayment.status === 'REGELBESTEUERUNG' ? 'IST' : 'PROFILE_YEAR_MISMATCH';
    }
    return 'SOLL_REGIME';
};
